<template>
  <ul>
    <li v-for="item in strArray" :key="item.id">
      <p>
        {{ $t(item.text) }}：
        <!-- 拼接路径 -->
        <template v-if="item.key === 'url'">
          <span>{{ urlFn() }}</span>
        </template>
        <!-- 传感器类型文本转换 -->
        <template v-else-if="item.key === 'type'">
          <span>{{ textTypeFn(rowData[item.key]) }}</span>
        </template>
        <!-- 配置文本转换 -->
        <template v-else-if="item.key === 'config_status'">
          <span>{{ configStatusFn(rowData[item.key]) }}</span>
        </template>
        <!-- 时间转换 -->
        <template
          v-else-if="
            item.key === 'create_time' ||
              item.key === 'update_time' ||
              item.key === 'stop_time'
          "
        >
          <span>{{ $timetransition(rowData[item.key]) }}</span>
        </template>

        <!-- <template v-else-if="item.key === 'status'">
          <span :style="styleFn(rowData[item.key])">{{ statusFn(rowData[item.key]) }}</span>
        </template>-->

        <span v-else>{{ rowData[item.key] }}</span>
      </p>
    </li>
    <template v-if="rowData.type === 1 || rowData.type === 2">
      <li
        v-for="item in isZigBee"
        :key="item.id"
        v-show="typeWay === 'bind' || typeWay === 'unbind'"
      >
        <p>
          {{ $t(item.text) }}：{{
            probeValue && probeValue[item.key] && probeValue[item.key].val
          }}
        </p>
      </li>

      <!--      采集间隔-->

      <li v-for="(value, key) in collectInterval" :key="key">
        <p>{{ key }}: {{ value }}</p>
      </li>
    </template>
  </ul>
</template>

<script>
import { configStatusConvert, gasTypeConvert } from '@/utils/convert'
import { transformCollectInterval } from '@/utils/transform/sensorTransForm'

export default {
  props: ['rowData', 'typeWay'],
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    probeValue () {
      if (typeof this.rowData.probe_value === 'string') {
        return JSON.parse(this.rowData.probe_value || '{}')
      }
      return this.rowData.probe_value
    },
    collectInterval () {
      return transformCollectInterval(this.rowData)
    }
  },
  data () {
    return {
      strArray: [
        {
          id: 1,
          text: 'public.belong',
          key: 'url'
        },
        {
          id: 2,
          text: 'public.carrier',
          key: 'carrier_name'
        },
        {
          id: 3,
          text: 'integration.gas_code',
          key: 'gas_code'
        },
        {
          id: 4,
          text: 'integration.gas_type',
          key: 'type'
        },

        {
          id: 5,
          text: $t('integration.sensor_deactivation_time'),
          key: 'stop_time'
        },
        {
          id: 6,
          text: 'device.config_status',
          key: 'config_status'
        },
        {
          id: 7,
          text: 'public.table_create_time',
          key: 'create_time'
        },
        {
          id: 11,
          text: $t('integration.forwarding_gateway_name'),
          key: 'gateway_name'
        },
        {
          id: 12,
          text: $t('integration.forwarding_gateway_mac'),
          key: 'ap_mac_addr'
        }
      ],
      isZigBee: [
        {
          id: 8,
          text: 'RSSI',
          key: 'rssi'
        },
        {
          id: 9,
          text: 'LQI',
          key: 'lqi'
        },
        {
          id: 10,
          text: $t('integration.voltage'),
          key: 'batt'
        }

        // {
        //   id: 13,
        //   text: $t('integration.normal_acquisition_interval'),
        //   key: 'collectInterval'
        // },
        // {
        //   id: 14,
        //   text: 'device.exception_sample_interval',
        //   key: 'exCollectInterval'
        // }
      ]
    }
  },
  mounted () {
    if (this.typeWay !== 'stop') {
      this.strArray.splice(4, 1)
    }
    if (this.typeWay === 'stop') {
      this.strArray.splice(5, 2)
    }
    if (this.typeWay === 'unknow') {
      this.strArray.splice(1, 1)
      this.strArray.splice(3, 1)
    }
  },
  methods: {
    urlFn () {
      let url = this.rowData.scene_name
      if (this.rowData.structure_name) {
        url += '/' + this.rowData.structure_name
      }
      if (this.rowData.carrier_name) {
        url += '/' + this.rowData.carrier_name
      }
      return url
    },
    textTypeFn (type) {
      return this.$t(gasTypeConvert(type).title)
    },
    configStatusFn (configStatus) {
      return this.$t(configStatusConvert(configStatus).title)
    },

    /**
     *
     * @param {*匹配字段} key
     * @param {*数组} array
     * @param {*返回数据} str
     */
    TOODChange (key, array, str, query) {
      var param = ''
      for (const item of array) {
        if (item[str] === key) {
          param = item[query]
          break
        }
      }
      return param
    },
    // statusFn(status) {
    //   return status === 1 ? this.$t('public.online') : this.$t('public.offline')
    // },
    styleFn (status) {
      return status === 1
        ? {
          color: '#65cea7',
          'font-weight': 'bold',
          cursor: 'pointer'
        }
        : {
          color: 'red',
          cursor: 'pointer'
        }
    }
  }
}
</script>

<style></style>
